import { Tooltip as MuiTooltip, useTheme } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface ITooltipProps {
  message: string;
}

const Tooltip: React.FC<ITooltipProps> = ({ message }) => {
  const theme = useTheme();
  return (
    <MuiTooltip
      title={message}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: theme.custom.palette.primary.default,
          },
        },
      }}
    >
      <InfoOutlinedIcon color={'primary'} fontSize={'small'} />
    </MuiTooltip>
  );
};

export default Tooltip;
